/**
 * Widgets de tela inicial (Android). Renderizados FORA do React (RemoteViews):
 * os componentes em widgets/ chamam i18n.t direto — o idioma é resolvido pelo
 * hydrateWidgetContext antes de cada render, inclusive na headless task.
 */
export const widgets = {
    quickActions: {
        title: 'Lançar rápido',
        newTransaction: 'Nova transação',
        tapToAdd: 'Toque para lançar',
        expense: 'Despesa',
        income: 'Receita',
        transfer: 'Transferência',
        card: 'Cartão',
    },
    balance: {
        balance: 'Saldo',
        monthBalance: 'Saldo de {{month}}',
        income: 'Entradas',
        expense: 'Saídas',
        lockedCta: 'Toque para desbloquear',
        error: 'Abra o Kontto para atualizar',
    },
    common: {
        openApp: 'Toque para abrir o Kontto',
    },
    invoice: {
        currentInvoice: 'Fatura atual',
        sampleCard: 'Cartão',
        available: 'Disponível {{value}}',
        ofLimit: '{{percent}}% do limite',
        limit: 'Limite {{value}}',
        empty: 'Sem cartão de crédito cadastrado',
    },
    bills: {
        titleSmall: 'A pagar',
        title: 'Próximas contas',
        dueToday: 'Vence hoje',
        monthTotal: '{{value}} no mês',
        more_one: '+{{count}} conta · {{value}}',
        more_other: '+{{count}} contas · {{value}}',
        empty: 'Nada a vencer até o fim do mês',
    },
    budgets: {
        titleSmall: 'Orçamento',
        title: 'Orçamentos',
        usedOfTotal: 'do total usado',
        totalOf: '{{spent}} de {{limit}}',
        daysLeft_one: 'Falta {{count}} dia',
        daysLeft_other: 'Faltam {{count}} dias',
        empty: 'Nenhum orçamento criado',
    },
    config: {
        title: 'Aparência do widget',
        cardTitle: 'Cartão exibido',
        subtitle: 'Escolha o fundo deste widget.',
        options: {
            brand: 'Kontto (gradiente)',
            auto: 'Automático (segue o sistema)',
            light: 'Claro',
            dark: 'Escuro',
        },
        save: 'Salvar',
        cancel: 'Cancelar',
    },
};
